module.exports = __webpack_public_path__ + "img/gsndc2760_2.5626994d.svg";